import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-6 pt-6 pb-20 md:px-8" }

import { computed, nextTick, ref, watch } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import FranchiseDayHeader from '@/components/franchise/FranchiseDayHeader.vue'
import AudienceNeue from '@/components/neue/AudienceNeue.vue'
import EmptyState from '@/components/neue/EmptyState.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import NeueWell from '@/components/neue/NeueWell.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import api from '@/store/api'


export default {
  __name: 'FranchiseDayLocation',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const date = computed(() => route.params.date)
const merchantId = computed(() => String(route.params.merchantId))
const dayPath = computed(() => `/dashboard/days/${date.value}`)
const locationPath = computed(() => `${dayPath.value}/locations/${merchantId.value}`)

const audienceId = ref(null)
const loading = ref(true)
const failed = ref(false)
let latestLoad = 0

// Every request the list makes goes out as the active location, so the route's location must be
// active before the list mounts.
const activateLocation = id =>
  store.state.activeFranchiseMerchantId === id ? null : store.dispatch('setActiveFranchiseMerchant', id)

const fetchAudienceId = (day, id) =>
  api
    .call('GET', `franchise/production_days/${day}/summary?merchant_ids[]=${id}`, {}, { receive: false })
    .then(response => response.data.locations?.find(location => String(location.merchant_id) === id)?.audience_id)

// Switching resets the object cache, which the list's rows read, so the list goes first.
const takeListDown = () => {
  loading.value = true
  audienceId.value = null
  return nextTick()
}

const load = async () => {
  if (!route.params.merchantId) return
  const token = ++latestLoad
  const [day, id] = [date.value, merchantId.value]
  failed.value = false
  await takeListDown()
  if (token !== latestLoad) return
  const found = await Promise.all([activateLocation(id), fetchAudienceId(day, id)])
    .then(([, audience]) => audience)
    .catch(() => {
      if (token === latestLoad) failed.value = true
    })
  if (token !== latestLoad) return
  audienceId.value = found ? String(found) : null
  loading.value = false
}

watch(() => `${date.value}/${merchantId.value}`, load, { immediate: true })

// The all locations day opens for the active location, so every way back to it (the back link, the
// switcher, the browser) clears the location first, once the list is gone.
const isAllLocationsDay = to => to.path.startsWith('/dashboard/days/') && !to.path.includes('/locations/')

onBeforeRouteLeave(async to => {
  if (!isAllLocationsDay(to) || !store.state.activeFranchiseMerchantId) return
  await takeListDown()
  await store.dispatch('setActiveFranchiseMerchant', null)
})

// Another location reloads this view through the route; All locations leaves through the guard above.
const changeLocation = id => router.push(id ? `${dayPath.value}/locations/${id}/overview` : `${dayPath.value}/overview`)

return (_ctx, _cache) => {
  return (audienceId.value)
    ? (_openBlock(), _createBlock(AudienceNeue, {
        key: audienceId.value,
        "audience-id": audienceId.value,
        "base-path": locationPath.value
      }, {
        top: _withCtx(({ sections }) => [
          _createVNode(FranchiseDayHeader, {
            date: date.value,
            "back-link": dayPath.value,
            "back-name": "All locations",
            sections: sections,
            onChange: changeLocation
          }, null, 8, ["date", "back-link", "sections"])
        ]),
        _: 1
      }, 8, ["audience-id", "base-path"]))
    : (_openBlock(), _createBlock(SecondaryNav, { key: 1 }, {
        top: _withCtx(() => [
          _createVNode(FranchiseDayHeader, {
            date: date.value,
            "back-link": dayPath.value,
            "back-name": "All locations",
            onChange: changeLocation
          }, null, 8, ["date", "back-link"])
        ]),
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(NeueLoading, {
              loading: loading.value,
              class: "min-h-[8rem]"
            }, {
              default: _withCtx(() => [
                (!loading.value)
                  ? (_openBlock(), _createBlock(NeueWell, {
                      key: 0,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        (failed.value)
                          ? (_openBlock(), _createBlock(EmptyState, {
                              key: 0,
                              plural: "orders",
                              description: "Could not load this location. Try again."
                            }))
                          : (_openBlock(), _createBlock(EmptyState, {
                              key: 1,
                              plural: "orders",
                              description: "This location has no production day on this date"
                            }))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }))
}
}

}